import React, { Component } from 'react';
import { Text } from '@clockout-dev/design-elements';
import Inherit from '../../../core/inherit';
import { UserStatusBadgeController } from './UserStatusBadge.controller';
import styles from './styles/userStatusBadge.module.scss';

/**
 * UserStatusBadge component
 * @extends {UserStatusBadgeController}
 * @extends {Component}
 */
class UserStatusBadge extends Inherit(UserStatusBadgeController, Component) {
    render() {
        const { status, className } = this.props;

        const cellClassName = this.getStatusCellClassName(className, styles);
        const dotClassName = this.getStatusDotClassName(status, styles);
        const label = this.getStatusLabel(status);

        return (
            <div className={cellClassName}>
                <span className={`${styles.statusDot} ${dotClassName}`} />
                <Text
                    as="span"
                    size="xs"
                    className={styles.statusText}>
                    {label}
                </Text>
            </div>
        );
    }
}

export default UserStatusBadge;
